// Enter your Api path 
export const apiPath = window.globalConfig.LegalAPIUrl;
// Custom headers
export const config = {
    headers: {
        'Authorization': window.globalConfig.LegalAPIKey
    }
}

// HMAC token
async function generateHmacHeader() {
    const secret = window.globalConfig.LegalAPIKey;
    const timestamp = Date.now().toString();

    const encoder = new TextEncoder();

    const key = await window.crypto.subtle.importKey(
        "raw",
        encoder.encode(secret),
        { name: "HMAC", hash: "SHA-256" },
        false,
        ["sign"]
    );

    const signatureBuffer = await window.crypto.subtle.sign(
        "HMAC",
        key,
        encoder.encode(timestamp)
    );

    const bytes = new Uint8Array(signatureBuffer);
    let binary = "";
    bytes.forEach(b => binary += String.fromCharCode(b));

    const signature = btoa(binary);

    return `HMAC ${timestamp}:${signature}`;
}
export async function getAuthConfig() {
    const authHeader = await generateHmacHeader();

    return {
        headers: {
            Authorization: authHeader
        }
    };
}

//JWT token
export const getConfigJWT = () => ({
    headers: {
        Authorization: `Bearer ${localStorage.getItem("token") || ""}`
    }
});
// Api endpoints with proper data
export const endPoints = {
    portalSettings: { endPoint: "/getportalsettings" },
    userApi: { endPoint: "/getuserinfo" },
    consentSave: { endPoint: "/updateconsent" },
    loginNews: { endPoint: "/login/getnews" },
    dashBoardNews: { endPoint: "/dashboard/getnews" },
    news: { endPoint: "/getnews" },
    getArea: { endPoint: "/getareas" },
    getRelationships: { endPoint: "/getrelationships" },
    getGeografiskBosteds: { endPoint: "/geografiskBosteds" },
    getBranches: { endPoint: "/getbranches" },
    getLawyer: { endPoint: "/getlawyers" },
    booking: { endPoint: "/booking" },
    getProfile: { endPoint: "/getprofileinfo" },
    saveProfile: { endPoint: "/updateprofile" },
    getAllCase: { endPoint: "/cases" },
    getCaseDetails: { endPoint: "/cases/legalcase" },
    uploadDocument: { endPoint: "/casedocument/upload" },
    allDocumentList: { endPoint: "/cases/getalldocuments" },
    createThread: { endPoint: "/case/threads" },
    allThread: { endPoint: "/case/allthreads" },
    getChat: { endPoint: "/case/messages" },
    createChat: { endPoint: "/case/messages" },
    updateChat: { endPoint: "/case/updateMessage" },
    getPendingSurvey: { endPoint: "/survey" },
    getSurvey: { endPoint: "/survey/details" },
    getPublicSurvey: { endPoint: "/publicsurvey/details" },
    postSurvey: { endPoint: "/survey/details" },
    getloginurl: { endPoint: "/getloginurl" },
    callbackforbankid: { endPoint: "/callbackforbankid" },
    callbackforsurveysigning: { endPoint: "/survey/callback" },
    checkvalidmarketsourceguid: { endPoint: "/checkvalidmarketsource" },
    createcase: { endPoint: "/createcase" },
    getSurveyResponses: { endPoint: "/responses" },
    getPublicSurveyResponses: { endPoint: "/publicsurvey/responses" }, 
    storeSurveyResponses: { endPoint: "/storeresponses" }
};

//Norway date time format
export const dateTimeFormat = { dateFormat: "DD.MM.YYYY, HH.mm", TimeFormat: "HH:mm", dateOnlyFormat: "DD.MM.YYYY" }
